module.exports = __webpack_public_path__ + "static/media/Badge_SvgFormationRSE_disabled_2.8227dfa5.svg";